/** How the UI names the actor behind a history entry or a layer change (ADR-009 §6.1). */
import type { ActorRef } from '@maipo/agent-protocol';

export const USER_ACTOR: ActorRef = Object.freeze({ kind: 'user' }) as ActorRef;

/** "You", "Agent · claude-code", "Add-on · kua.recraft", "Action · Sharpen". */
export function actorDisplayName(actor: ActorRef): string {
  switch (actor.kind) {
    case 'user': return 'You';
    case 'agent': return `Agent · ${actor.client}`;
    case 'addon': return `Add-on · ${actor.id}`;
    case 'replay': return `Action · ${actor.action}`;
  }
}

const PREFIX: Record<ActorRef['kind'], string> = { user: '', agent: 'Agent · ', addon: 'Add-on · ', replay: 'Action · ' };

/**
 * Transaction labels carry their actor as a prefix ("Agent · Lower headline")
 * so undo menus stay unambiguous; the History panel shows the actor
 * separately and drops the repeated prefix from the row text.
 */
export function withoutActorPrefix(label: string, actor: ActorRef): string {
  const prefix = PREFIX[actor.kind];
  return prefix && label.startsWith(prefix) ? label.slice(prefix.length) : label;
}
